<template>
  <!-- 钱包余额卡片，钱包入口与钱包页共用 -->
  <section
    :class="['section-wrapper', 'balance-card', classNames]"
    v-if="allowUseMember"
  >
    <div class="wallet-wrapper flex-col-center" v-if="page === 'myWallet'">
      <div class="first_line__container space-between">
        <p>T-Wallet</p>
        <div class="wallet-entry" @click="goto('expensesRecord')">
          {{ $t('wallet.my_bill') }}<span class="right-arrow"></span>
        </div>
      </div>
      <div class="account-balance">
        <p class="amount flex-center">
          <span>{{
            (walletBalance || accountBalance) | formatCurrency(region)
          }}</span>
          <img
            alt=""
            v-lazy="
              require(`@/assets/images/wallet/T-coin${
                accountStatus === 2 ? '-grey' : ''
              }.png`)
            "
          />
        </p>
        <p class="desc">{{ $t('wallet.account_balance') }}</p>
      </div>
      <div
        v-if="page !== 'myWallet'"
        class="btn recharge-btn"
        @click="goto('myWallet')"
      >
        {{ $t('wallet.topup') }}
      </div>
      <slot></slot>
    </div>

    <!-- 我的钱包 新版 只在首页左侧菜单显示 -->
    <div class="new-wallet-content" v-else>
      <div
        class="wallet space-between"
        :class="layoutClassName"
        @click="goto('myWallet')"
      >
        <div class="lt-card">
          <img class="wallet-icon" :src="walletIcon" />
          <span class="wallet-name">T-Wallet</span>
        </div>
        <div class="rt-card">
          <h2>
            {{ (walletBalance || accountBalance) | formatCurrency(region) }}
          </h2>
          <img
            class="kb-icon"
            :src="
              require(`@/assets/images/wallet/T-coin${
                accountStatus === 2 ? '-grey' : ''
              }.png`)
            "
          />
          <van-icon :color="arrowColor" name="arrow" size="14" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import { priceFormat } from '@/utils/priceFormat'
  import { trackWalletEntry } from '@/pages/Wallet/firebase'
  import { tryToNative, hideAppSidebar } from '@/utils/native'
  import { urlAddNotNullParams } from '@/utils/url'

  export default {
    name: 'balance-card',
    props: {
      page: {
        type: String,
        default: 'home',
      },
      walletBalance: {
        type: [Number, String],
        default: 0,
      },
    },
    computed: {
      ...mapState([
        'region',
        'gameName',
        'paymentAccountInfo',
        'allowUseMember',
        'isApp',
        'userInfo',
      ]),
      ...mapGetters(['appBaseUrl', 'isNewLayout']),
      accountStatus() {
        // 支付账户状态：1正常 2冻结 3注销
        const { paymentAccountInfo } = this
        return (paymentAccountInfo && paymentAccountInfo.status) || 1
      },
      frozenClass() {
        return this.accountStatus === 2 ? 'account-frozen' : ''
      },
      walletIcon() {
        const { isNewLayout, accountStatus } = this
        return require(`@/assets/images/wallet/wallet-icon${
          accountStatus === 2 ? '-grey' : ''
        }${isNewLayout ? '-2' : ''}.png`)
      },
      arrowColor() {
        const { isNewLayout, accountStatus } = this
        const isFrozen = accountStatus === 2
        return isNewLayout ? '#ffffff' : isFrozen ? '#BBBBBB' : '#F96000'
      },
      accountBalance() {
        const { paymentAccountInfo } = this
        return (paymentAccountInfo && paymentAccountInfo.amount) || 0
      },
      layoutClassName() {
        return this.isNewLayout ? 'new-version' : ''
      },
      classNames() {
        let classNames = [this.page, this.frozenClass, this.layoutClassName]
        let bindAppClass = this.isApp ? 'balance-card-app' : ''
        bindAppClass && classNames.push(bindAppClass)
        return classNames
      },
    },
    filters: {
      formatCurrency(input, region) {
        return priceFormat(input, region, {
          style: 'decimal',
          minimumFractionDigits: 0,
        })
      },
    },
    methods: {
      goto(pathName) {
        if (pathName === 'myWallet') {
          trackWalletEntry({
            page: this.gameName || 'home',
          })
        }
        const { game } = this.$route.query
        const query = {
          ...this.$route.query,
          from: this.page === 'pay-result' ? game : this.page,
        }
        delete query.orderNo
        if (this.page === 'myWallet') {
          this.$router_push({
            path: `/${pathName}`,
            query,
          })
          return
        }
        tryToNative({
          url: urlAddNotNullParams(`${this.appBaseUrl}/${pathName}`, query),
          params: JSON.stringify({
            requireLogin: true,
          }),
        })
          .then(() => {
            hideAppSidebar()
          })
          .catch(() => {
            this.$router_push({
              path: `/${pathName}`,
              query,
            })
          })
      },
    },
  }
</script>
<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
